import React from "react";
import ReactDOM from "react-dom";
import thunk from "redux-thunk";
import { applyMiddleware, createStore, compose } from "redux";
import { createBrowserHistory } from "history";
import { Provider } from 'react-redux';
import { Router, Route, Switch } from "react-router-dom";

import indexRoutes from "routes/index.jsx";
import rootReducer from "./reducers/reducers";
import { axiosProductionURLSetup, redirectWhenUnauthorized } from "./config/axios";
import { momentConfigLocale } from "./config/moment";
import "./config/chart";

import "assets/scss/material-dashboard-pro-react.css";
import "moment/locale/pt-br";

let composeEnhancers = compose;
let middleware = [thunk];

if (process.env.NODE_ENV !== 'production') {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers;
  middleware.push(require('redux-freeze'));
}

const hist = createBrowserHistory();
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware)));

axiosProductionURLSetup();
momentConfigLocale();
redirectWhenUnauthorized(store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <Route component={prop.component} key={key} path={prop.path} />;
        })}
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js